import { render, staticRenderFns } from "./scoreboard.vue?vue&type=template&id=d501bd92&scoped=true&lang=html&"
import script from "./scoreboard.vue?vue&type=script&lang=js&"
export * from "./scoreboard.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard.vue?vue&type=style&index=0&id=d501bd92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d501bd92",
  null
  
)

export default component.exports